import styled from "styled-components";

export const FooterWrapper = styled.section`
  text-align: center;
  margin-bottom: 40px;
  font-size: 18px;
  color: var(--grey);
`;
export const Nav = styled.div`
  margin: 0 auto 20px auto;
  display: flex;
  width: 80%;
  justify-content: space-between;
`;
